/* ===== Poundcake's Merch theme JS ===== */
(function () {
  'use strict';

  var money = function (cents) {
    return '$' + (cents / 100).toFixed(2);
  };

  /* ---- Cart drawer ---- */
  var drawer = document.querySelector('[data-cart-drawer]');
  function openDrawer() { if (drawer) drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function closeDrawer() { if (drawer) drawer.classList.remove('is-open'); document.body.style.overflow = ''; }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-toggle]')) { e.preventDefault(); refreshCart().then(openDrawer); }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawer(); }
    if (e.target.closest('[data-menu-toggle]')) {
      var m = document.querySelector('[data-mobile-menu]');
      if (m) m.classList.toggle('is-open');
    }
  });

  /* ---- Cart count + drawer contents ---- */
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  function renderDrawer(cart) {
    var body = document.querySelector('[data-drawer-body]');
    var foot = document.querySelector('[data-drawer-subtotal]');
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<p class="muted" style="padding:24px 0;">Your cart is empty.</p>';
      if (foot) foot.textContent = money(0);
      return;
    }
    body.innerHTML = cart.items.map(function (item) {
      var img = item.image ? '<img src="' + item.image + '" alt="" width="64" height="64" style="object-fit:cover;">' : '';
      return '<div class="cart-line">' +
        '<div class="cart-line__media">' + img + '</div>' +
        '<div><div class="cart-line__title">' + item.product_title + '</div>' +
        '<div class="cart-line__meta">' + (item.variant_title || '') + ' · Qty ' + item.quantity + '</div>' +
        '<button class="cart-line__meta" style="background:none;border:0;color:inherit;text-decoration:underline;padding:4px 0;" data-remove="' + item.key + '">Remove</button></div>' +
        '<div class="card__price">' + money(item.final_line_price) + '</div>' +
        '</div>';
    }).join('');
    if (foot) foot.textContent = money(cart.total_price);
  }

  function refreshCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); renderDrawer(cart); return cart; })
      .catch(function () { return { items: [], item_count: 0, total_price: 0 }; });
  }

  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-remove]');
    if (!rm) return;
    e.preventDefault();
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: rm.getAttribute('data-remove'), quantity: 0 })
    }).then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); renderDrawer(cart); });
  });

  /* ---- Add to cart (product form) ---- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[data-add-btn]');
      if (btn) { btn.setAttribute('disabled', 'disabled'); btn.dataset.label = btn.textContent; btn.textContent = 'Adding…'; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: form.querySelector('[name="id"]').value,
          quantity: parseInt((form.querySelector('[name="quantity"]') || {}).value || '1', 10)
        })
      }).then(function (r) { return r.json(); })
        .then(function () { return refreshCart(); })
        .then(function () { openDrawer(); })
        .catch(function () { form.submit(); })
        .finally(function () { if (btn) { btn.removeAttribute('disabled'); btn.textContent = btn.dataset.label || 'Add to cart'; } });
    });
  });

  /* ---- Variant selection ---- */
  document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
    var form = picker.closest('form') || document.querySelector('[data-product-form]');
    var variants = JSON.parse(picker.getAttribute('data-variants') || '[]');
    var idInput = form && form.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-price]');
    var addBtn = form && form.querySelector('[data-add-btn]');

    function select(value) {
      picker.querySelectorAll('[data-swatch]').forEach(function (s) {
        s.setAttribute('aria-pressed', s.getAttribute('data-value') === value ? 'true' : 'false');
      });
      var v = variants.filter(function (x) { return x.title === value; })[0];
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (addBtn) {
        if (v.available) { addBtn.removeAttribute('disabled'); addBtn.textContent = 'Add to cart'; }
        else { addBtn.setAttribute('disabled', 'disabled'); addBtn.textContent = 'Sold out'; }
      }
    }

    picker.addEventListener('click', function (e) {
      var sw = e.target.closest('[data-swatch]');
      if (sw && !sw.disabled) select(sw.getAttribute('data-value'));
    });

    var first = picker.querySelector('[data-swatch]:not([disabled])');
    if (first) select(first.getAttribute('data-value'));
  });

  /* ---- Product gallery thumbs ---- */
  document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var main = document.querySelector('[data-main-image]');
      if (main) main.src = thumb.getAttribute('data-full');
      document.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  /* ---- Quantity steppers ---- */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (!step) return;
    var input = step.parentElement.querySelector('input');
    var val = parseInt(input.value || '1', 10);
    val += parseInt(step.getAttribute('data-qty-step'), 10);
    input.value = Math.max(1, val);
  });

  refreshCart();
})();
